import { useEffect, useState } from 'react'
import { peer } from 'config/skyway';
import { MeshRoom, SfuRoom } from 'skyway-js';

type RoomInfo = {
  id: string;
  name: string;
  member?: string[];
}

type UseRoomValue = {
  joinRoom: (name: string) => Promise<void>;
  makeRoom: (name: string) => RoomInfo;
  roomList: Array<RoomInfo>;

}

const presetRooms = [
{
  id: 'r1',
  name: '05/29の会場はこちら！',
},
{
  id: 'r2',
  name: 'さぶ',
},
]

const toRoomInfo = (room:SfuRoom| MeshRoom): RoomInfo => {
  return {
    id: room.name,
    name: room.name,
    member: ('members' in room ? room.members : undefined)
  };
}

const createRoomInfoList = () => {
  const maked = Object.keys(peer.rooms).map((id: string) => {
    return toRoomInfo(peer.rooms[id]);
  })

  return maked.concat(presetRooms) ;
}

export const useRoomList = (): UseRoomValue => {

  const [roomList, setRoomList] = useState<Array<RoomInfo>>(createRoomInfoList());

  useEffect(()=>{
    setRoomList(createRoomInfoList);

    console.log(peer.rooms);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [peer.rooms])

  const joinRoom = async (name: string): Promise<void> => {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    peer.joinRoom(name, {
      mode: "sfu",
      stream: stream,
    }) as SfuRoom;
  }

  const makeRoom = (name: string): RoomInfo => {
    peer.joinRoom(name, {
      mode: "sfu",
    }) as SfuRoom;

    const room = peer.rooms[name];
    return {
      id: room.name,
      name: room.name,
      member: ('members' in room ? room.members : undefined)
    };
  }


  return { joinRoom, roomList, makeRoom } ;
}
